<template>
  <slot />
</template>

<script>
import 'intersection-observer'

export default {
  name: 'VisibilityObserver',

  emits: ['visible', 'unvisible'],

  props: {
    threshold: {
      type: [Array, Number],
      required: false,
      default: 0.1,
    },

    root: {
      type: Element,
      required: false,
      default: null,
    },

    rootMargin: {
      type: String,
      required: false,
      default: '0px',
    },
  },

  data() {
    return {
      observer: new IntersectionObserver(
        ([entry]) => {
          const eventName = entry.isIntersecting ? 'visible' : 'unvisible'

          this.$emit(eventName, this)
        },
        {
          root: this.root,
          rootMargin: this.rootMargin,
          threshold: this.threshold,
        },
      ),
    }
  },

  mounted() {
    this.observe()
  },

  unmounted() {
    this.unobserve()
  },

  methods: {
    observe(element) {
      const { observer } = this

      if (!element) {
        const defaultSlot = this.$slots.default()

        element = (defaultSlot?.[0] ?? defaultSlot)?.el
      }

      if (!element) return

      observer.observe(element)
    },

    unobserve() {
      this.observer?.disconnect?.()
    },
  },
}
</script>
